// ABOUTME: Layout route for /library/$documentId.
// ABOUTME: Pass-through layout that renders child routes via Outlet.

import { Outlet, createFileRoute } from "@tanstack/react-router";

interface DocumentSearchParams {
  returnToFolderId?: string;
  /** 1-based PDF page to open on. Used by citation deep-links (e.g. from Teams). */
  page?: number;
}

export const Route = createFileRoute("/_authenticated/library/$documentId")({
  validateSearch: (search: Record<string, unknown>): DocumentSearchParams => {
    const page = Number(search.page);
    return {
      returnToFolderId: (search.returnToFolderId as string) || undefined,
      page: Number.isFinite(page) && page > 0 ? page : undefined,
    };
  },
  component: () => <Outlet />,
});
